export default function validate(values, isRequired, type) {
	let errors = { passwordLength: false };
	let information = {};

	if (values.length === 0 && isRequired) {
		information.isEmpty = "No puedes dejar esta fila en blanco";
	}
	if (type === "email" && !/\S+@\S+\.\S+/.test(values)) {
		information.email = "El correo ingresado es incorrecto";
	}
	if (type === "email" && /\S+@(?:servipag)+\.\S+/.test(values)) {
		information.corpEmail =
			"Hemos detectado que tienes una cuenta corporativa, necesitamos mayor seguridad en tu contraseña";
	}
	if (type === "phone" && !/^\d+$/.test(values)) {
		information.phoneDigit =
			"Su número telefónico debe incluir solo números";
	}
	if (type === "phone" && values.length !== 11) {
		information.phoneLength =
			"Su número telefónico debe incluir 11 dígitos incluyendo el código de área";
	}
	if (type === "id" && !/^\d{8}[0123456789abcdefghijk]$/.test(values)) {
		information.idFormat =
			"Su identificación debe seguir el formato correcto";
	}

	if (
		(type === "password-strong" && values.length <= 8) ||
		(type === "password-weak" && values.length <= 8)
	) {
		errors.passwordLength = "Mayor a 7 caracteres";
	} else {
		errors.passwordLength = "checked";
	}
	if (
		(type === "password-strong" && !/\d+/.test(values)) ||
		(type === "password-confirm-strong" && !/\d+/.test(values))
	) {
		errors.passwordNumber = "Un digito";
	} else {
		errors.passwordNumber = "checked";
	}
	if (
		(type === "password-strong" && !/[a-z]+/.test(values)) ||
		(type === "password-confirm-strong" && !/[a-z]+/.test(values))
	) {
		errors.passwordMinus = "Una letra minúscula";
	} else {
		errors.passwordMinus = "checked";
	}
	if (
		(type === "password-strong" && !/[A-Z]+/.test(values)) ||
		(type === "password-confirm-strong" && !/[A-Z]+/.test(values))
	) {
		errors.passwordMayus = "Una letra mayúscula";
	} else {
		errors.passwordMayus = "checked";
	}
	if (
		(type === "password-strong" && !/[@$!%*#?&./\-_]+/.test(values)) ||
		(type === "password-confirm-strong" && !/[@$!%*#?&./\-_]+/.test(values))
	) {
		errors.passwordSpecial = "Un símbolo";
	} else {
		errors.passwordSpecial = "checked";
	}

	return { errors, information };
}
